<app-form-input
[parentForm]="parentForm"
[disabled]="disabled"

[value]="adr?.pays"

[label]="step12.getpays"
[type]="'select'"
[typeSelect]="optionsSelectType" [optionsWithCode]="optionsSelect"
	[rule]="'pattern_25'"
	[errorMessage]="{'pattern' : 'ctr_48'}"
	[name]="paysCtrName">
</app-form-input>

<app-type-voie  [uid]="'voie'+getUid()" [parentForm]="parentForm"
[disabled]="disabled" *ngIf="isFrance"
 [voie]="adr?.voie"></app-type-voie>
<app-form-input-error *ngIf="isFrance" [activeForm]="parentForm" [name]="getStepId() + rg3 + filtreRG + (nbIteration + 1)" [id]="getStepId() + rg3 + filtreRG + (nbIteration + 1)"></app-form-input-error>

<app-type-voie  *ngIf="!isFrance" [uid]="'voiee'+getUid()" [parentForm]="parentForm"
[disabled]="disabled"
 [voie]="adr?.voie_e"></app-type-voie>
 <app-form-input-error *ngIf="!isFrance" [activeForm]="parentForm" [name]="getStepId() + rg4 + filtreRG + (nbIteration + 1)" [id]="getStepId() + rg4 + filtreRG + (nbIteration + 1)"></app-form-input-error>

<app-form-input *ngIf="isFrance"
[parentForm]="parentForm"
[disabled]="disabled"

[value]="adr?.cp"

[label]="step12.getcp"
[type]="'text'" [rule]="'pattern_3'"
[errorMessage]="{'pattern' : 'ctr_43'}"
[name]="getUid()+'_SepAtt_cp'">
</app-form-input>

<app-form-input *ngIf="!isFrance"
[parentForm]="parentForm"
[disabled]="disabled"

[value]="adr?.cp_e"

[label]="step12.getcp_e"
[type]="'text'" [rule]="'pattern_31|minSize_1|maxSize_10'"
[name]="getUid()+'_SepAtt_cp_e'">
</app-form-input>

<app-form-input
[parentForm]="parentForm"
[disabled]="disabled"

[value]="adr?.ville"

[label]="step12.getville"
[type]="'text'" [rule]="'pattern_21|maxSize_100'"
[errorMessage]="{'required' : 'ctr_629', 'pattern' : 'ctr_40_HorsDef', 'minLength' : 'ctr_40'}"
[name]="getUid()+'_SepAtt_ville'">
</app-form-input>
<app-form-input-error *ngIf="isFrance" [activeForm]="parentForm" [name]="getStepId() + rg5 + filtreRG + (nbIteration + 1)" [id]="getStepId() + rg5 + filtreRG + (nbIteration + 1)"></app-form-input-error>
<app-form-input-error *ngIf="isFrance" [activeForm]="parentForm" [name]="getStepId() + rg6 + filtreRG + (nbIteration + 1)" [id]="getStepId() + rg6 + filtreRG + (nbIteration + 1)"></app-form-input-error>
<app-form-input-error *ngIf="isFrance" [activeForm]="parentForm" [name]="getStepId() + rg7 + filtreRG + (nbIteration + 1)" [id]="getStepId() + rg7 + filtreRG + (nbIteration + 1)"></app-form-input-error>
<app-form-input-error *ngIf="!isFrance" [activeForm]="parentForm" [name]="getStepId() + rg8 + filtreRG + (nbIteration + 1)" [id]="getStepId() + rg8 + filtreRG + (nbIteration + 1)"></app-form-input-error>
<app-form-input-error *ngIf="!isFrance" [activeForm]="parentForm" [name]="getStepId() + rg9 + filtreRG + (nbIteration + 1)" [id]="getStepId() + rg9 + filtreRG + (nbIteration + 1)"></app-form-input-error>
<app-form-input-error *ngIf="!isFrance" [activeForm]="parentForm" [name]="getStepId() + rg10 + filtreRG + (nbIteration + 1)" [id]="getStepId() + rg10 + filtreRG + (nbIteration + 1)"></app-form-input-error>

<app-form-input *ngIf="false"
[parentForm]="parentForm"
[disabled]="disabled"

[value]="adr?.bp"

[label]="'bp'"
[type]="'number'" [rule]="''"
[name]="getUid()+'_SepAtt_bp'">
</app-form-input>


<app-form-input  *ngIf="false"
[parentForm]="parentForm"
[disabled]="disabled"

[value]="adr?.lieuDit"

[label]="'lieuDit'"
[type]="'text'" [rule]="''"
[name]="getUid()+'_SepAtt_lieuDit'">
</app-form-input>

<app-form-input *ngIf="false"
[parentForm]="parentForm"
[disabled]="disabled"

[value]="adr?.cx"

[label]="'cx'"
[type]="'number'" [rule]="''"
[name]="getUid()+'_SepAtt_cx'">
</app-form-input>
